<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12" md="7" lg="5" id="login-form" class="p-3 p-lg-4 p-xl-5" v-if="!use2factor">
        <b-row>
          <b-col cols="12" md="4" class="text-center text-lg-left py-3 py-md-5" align-self="center">
            <img :src="$store.getters.ecosystem.logoLogin" :alt="$store.getters.ecosystem.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
          </b-col>
          <b-col cols="12" md="8" class="text-center text-md-right text-muted py-3 py-md-5" align-self="center">

          </b-col>
        </b-row>

        <b-alert :show="justRegistered" variant="success">
          <h3 v-translate>Welcome to Moova!</h3>
          <h4 v-translate>Your user has been created. Please log in below with your credentials.</h4>
        </b-alert>

        <b-alert :show="$route.query.error && $route.query.error === 'no-permission'" variant="danger">
          <h3 v-translate>ERROR</h3>
          <h4 v-translate>Your user does not have the required permissions.</h4>
        </b-alert>

        <b-row class="py-3">
          <b-col class="text-center text-md-left">
            <h2 v-translate>Log in to your account</h2>
            <br>
            <form @submit.prevent="login" class="form form--login grid">
              <div class="form-group label-floating">
                <input type="email" :placeholder="$gettext('E-mail')" class="form-control" id="login__email" v-model="email" required>
              </div>
              <div class="form-group">
                <input type="password" :placeholder="$gettext('Password')" class="form-control" id="login__password" v-model="password" required>
              </div>
              <div class="form-group label-floating">
                <input type="text" :placeholder="$gettext('Client')" class="form-control" id="login__client" v-model="client" required>
              </div>
              <b-row>
                <b-col md="6" order="1" order-md="12" class="text-center text-md-right">
                  <button type="submit" class="btn btn-lg btn-primary" :disabled="!email || !password || !client"><strong v-translate>Log in</strong></button>
                </b-col>
                <b-col md="6" order="12" order-md="1" class="text-center text-md-left">
                  <p class="forgot">
                    <router-link to="password/reset" v-translate>Forgot password?</router-link>
                  </p>
                </b-col>
              </b-row>
            </form>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" md="7" lg="5" id="login-form" class="p-3 p-lg-4 p-xl-5" v-else>
        <b-row>
          <b-col cols="12" md="4" class="text-center text-lg-left py-3 py-md-5" align-self="center">
            <img :src="$store.getters.ecosystem.logoLogin" :alt="$store.getters.ecosystem.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
          </b-col>
        </b-row>
        <form @submit.prevent="login" class="form form--login grid">
          <b-row class="py-3">
            <b-col class="text-center text-md-left">
              <h2 v-translate>Enter the code</h2>
              <b-alert :show="!codeExpired" variant="info">
                <h3 v-translate>We sent you a confirmation code</h3>
                <p v-translate>The code is valid for 15 minutes</p>
                <h4 v-translate>Please, enter it below</h4>
              </b-alert>
              <b-alert :show="codeExpired" variant="danger">
                <h3 v-translate>Confirmation code has expired</h3>
                <h4 v-translate>We are sending you a new code to enter below</h4>
              </b-alert>
              <pincode-input
                v-model="twofaCode"
                placeholder=" "
                :length="6"
                :secure="true"
                class="my-4"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" order="1" order-md="12" class="text-center text-md-right">
              <button type="submit" class="btn btn-lg btn-primary" :disabled="!email || !password || !client || !twofaCode"><strong v-translate>Log in</strong></button>
            </b-col>
            <b-col md="6" order="12" order-md="1" class="text-center text-md-left">
              <p class="forgot">
                <b-link @click.prevent="login(); toastResend();" v-translate>Didn't get the code? Click here to re-send it</b-link>
              </p>
            </b-col>
          </b-row>
        </form>
      </b-col>
      <b-col sm="12" md="5" lg="7" id="login-bg" class="d-none d-md-block">

      </b-col>
    </b-row>
    <span class="d-none" v-translate>Password</span>
  </b-container>
</template>
<script>
import PincodeInput from 'vue-pincode-input'

export default {
  name: 'LoginPage',
  title() {
    return this.$gettext('Log in to your account')
  },
  components: {
    PincodeInput
  },
  data() {
    return {
      email: '',
      password: '',
      client: '',
      justRegistered: false,
      use2factor: false,
      codeExpired: false,
      twofaCode: ''
    }
  },
  mounted() {
    if (this.$route.query.r === 'true') {
      this.justRegistered = true
    }
  },
  methods: {
    login() {
      let loginData = {
        user: {
          email: this.email.trim(),
          password: this.password,
          'x-moova-ecosystem-name': this.client.trim()
        }
      }
      if (this.twofaCode) {
        loginData = {
          user: {
            email: this.email.trim(),
            password: this.password,
            'x-moova-ecosystem-name': this.client.trim(),
            '2fa_code': this.twofaCode
          }
        }
      }
      this.$store.dispatch('login', loginData).then(() => {
        this.setup()
        this.$nextTick(() => {
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect)
          } else {
            this.$router.push('summary')
          }
        })
      }, error => {
        console.log(error.status)
        let message = ''
        if (error.status === 428 && error.body.code === 42805) {
          this.use2factor = true
          this.$root.$children[0].$refs.simplert.justCloseSimplert()
        } else if (error.status === 428 && error.body.code === 42806) {
          this.use2factor = true
          this.codeExpired = true
          this.twofaCode = ''
          this.$root.$children[0].$refs.simplert.justCloseSimplert()
        } else {
          if (error.status === 422) {
            for (const errorItem of error.body.errors) {
              message += '- ' + errorItem.detail + '<br>'
            }
          } else {
            if (!this.twofaCode || this.twofaCode === '') {
              message = this.$gettext('Invalid email, password or client') // error.body.message
            } else {
              message = this.$gettext('Wrong code, please try again')
              this.twofaCode = ''
            }
          }
          const obj = {
            title: 'ERROR',
            message,
            type: 'error',
            customCloseBtnText: this.$gettext('Close')
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        }
      })
    },
    authenticate(provider) {
      this.$store.dispatch('authenticate', { provider }).then(() => {
        this.$router.push('summary')
      }, error => {
        console.log(error)
        let message = ''
        if (error.status === 422) {
          for (const errorItem of error.body.errors) {
            message += '- ' + errorItem.detail + '<br>'
          }
        } else {
          message = this.$gettext('Invalid credentials') // error.body.messageerror.body.message
        }
        const obj = {
          title: 'ERROR',
          message,
          type: 'error',
          customCloseBtnText: this.$gettext('Close')
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      })
    },
    toastResend() {
      this.makeToast(this.$gettext('Notice'), this.$gettext('We are sending you a new code to enter below') + '. ' + this.$gettext('The code is valid for 15 minutes'), 'info', true, 5000)
    }
  }
}
</script>
